<template>

       <div class="result tc">
          <van-skeleton  :row="4" :loading="loading">
            <img :src="result.src" alt="">
            <h3>{{result.title}}</h3>
            <p class="fs13" style="color:#666">{{result.desc}}</p>
            <p class="fs13" style="color:#666">{{result.desc1}}</p>

            <div class="btns">
                <button @click="btnClick">{{result.btnsText}}</button>
            </div>
          </van-skeleton>
      </div>


</template>

<script>
import {callApp} from '@/libs/bridge'
import {orderLkyQueryOrderStatus,orderLkyPay} from "@a/lvkeyun";
export default {
  name: 'result',
  data() {
    return {
        result:{
            src:'',
            title:'',
            desc:'',
            desc1:'',
            btnsText:''
        },
        orderId:this.$basicsTools.getQueryUrl('orderId'),
        time:0,
        loading:true
    }
  },
  created(){
    this.queryfrom()
  },
  mounted(){
    // callApp('redirectUrl','empty')
  },
  methods:{
    // 返回首页
    // goBack(){
    //   // callApp('redirectUrl',window.location.origin+'/#/member')
    // },
    // 循环查询订单
    queryfrom(){
      this.$toast.loading({
          message: '请稍等...',
          forbidClick: true,
          duration:0
     });

     let timer = setInterval(()=>{
         this.getqueryOrderPay()
         if(this.time > 2) clearInterval(timer)
         this.time ++
      },1500)

    },
    // 查询订单
    getqueryOrderPay(){
      orderLkyQueryOrderStatus({orderId:this.orderId}).then(res=>{
        if(!res.code && this.time > 2){
          this.loading = false;
           // 未支付
            this.result.src = res.data.status === 1000 ? require('@/assets/imgs/members/pay-fail.png') : require('@/assets/imgs/members/pay-success.png')
            this.result.title = res.data.status === 1000 ? '支付失败，请重新支付!' :'支付成功！'
            this.result.desc = res.data.status === 1000 ?  '' :''
            this.result.btnsText = res.data.status === 1000 ?  '重新支付' : '我的流量包'
            if(res.data.status !== 1000){
              callApp('finishActivity')
              // callApp('lvkeyunSuccessEvent')
            }else{
              let lvkeyunData = localStorage.getItem('lvkeyunData') ? JSON.parse(localStorage.getItem('lvkeyunData')) : ''
              callApp('lvkeyunFailed',lvkeyunData)
            }
            this.$toast.clear()
        }
      })
    },
    btnClick(){
        // if(this.result.btnsText === '重新购买')  return this.$router.push({name:'recharge'})
        if(this.result.btnsText === '重新支付'){
            orderLkyPay({
              orderId:this.orderId,
              payType:2
            }).then(({data})=>{
              const payResultMsg = JSON.parse(data.payResultMsg)
              window.location.href = payResultMsg.h5_url
              return data
            })
        }else{
          callApp('lvkeyunOpertaion')
        }
        // callApp('toGrabOrder')
    }
  }
 }
</script>

<style lang="scss" scoped>
  .result{
      padding:40px 0;
      h3{
          margin-bottom: 16px;
          margin-top: 9px;
          font-size: 18px;
      }
      .btns{
          margin-top: 80px;
           button {
            width: 90%;
            line-height: 40px;
            background: #4A549E;
            color: #ffffff;
            font-size: 15px;
            outline: none;
            border: none;
            border-radius: 44px;
        }

        a{
            display: block;
            margin-top:16px;
            // 111
            color: #4A549E;
        }
      }
  }
</style>
